import React from "react";
import { createStyles } from "@mantine/core";
import { tokens } from "@blurb/codex-react";
import ReactJson from "@microlink/react-json-view";

const useStyles = createStyles(() => ({
  // react-json-view sets font-family and background as inline styles on its root,
  // so they can only be overridden here with !important.
  tree: {
    "& .react-json-view": {
      fontFamily: `${tokens.font.family.mono} !important`,
      backgroundColor: "transparent !important",
    },
  },
}));

interface JsonTreeProps {
  data: unknown;
}

/** Interactive, collapsible JSON tree; renders nothing when the value is not an object. */
export const JsonTree: React.FC<JsonTreeProps> = ({ data }) => {
  const { classes } = useStyles();
  if (typeof data !== "object" || data === null) {
    return null;
  }
  return (
    <div className={classes.tree} data-testid="json-tree">
      <ReactJson src={data} collapsed={1} displayObjectSize displayDataTypes={false} name={false} />
    </div>
  );
};
